import React from 'react';
import ChevronRight from './chevron-right';

const style = {
  transform: 'rotate(180deg)',
};

function ChevronLeft() {
  return (
    <ChevronRight
      style={style}
      className="icon-chevron-left"
    />
  );
}

export default ChevronLeft;
